import React from "react";
import "./Loader.scss";

const Loader = () => {
  return (
    <div
      className={`loader flex-it flex-align-item-center flex-justify-center`}
    >
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;
